<script>
  /**
   * Bulma のシンプルなテキスト入力欄
   */
  export let id = null
  export let name
  export let type = 'text'
  export let label = ''
  export let inputAttributes = null // 編集用inputタグに付けたい属性をセットする
  export let value = undefined

  // ID指定がない場合のデフォルトID設定
  $: assuredId = id ? id : `${name}TextInput`

  // inputタグの動的type設定
  //  @see https://github.com/sveltejs/svelte/issues/3921#issuecomment-880664654
  const setType = node => {
    node.type = type
  }
</script>

<div class="field">
  <label class="label" for={assuredId}>{label}</label>
  <slot />
  <div class="control">
    <!-- 編集用のinputタグ -->
    <input
      use:setType
      id={assuredId}
      data-testid={assuredId}
      class="input"
      bind:value
      {...inputAttributes}
    />
  </div>
</div>
